import CONFIG from '@/constants/config.js';
export var imageMixin = {
  data: () => ({}),
  computed: {
    imageBaseUrl() {
      return CONFIG.IMAGE_BASE_URL + '/';
    },
    defaultImage() {
      return CONFIG.TASK_DEFAULT_IMAGE;
    },
  },
  methods: {
    isImage(img) {
      return (
        this._.isString(img) &&
        img
          .split('?')[0]
          .toLowerCase()
          .match(/.(jpg|jpeg|png|gif)$/i)
      );
    },
    isVideo(img) {
      return (
        this._.isString(img) &&
        img
          .split('?')[0]
          .toLowerCase()
          .match(/.(mpg|mpeg|mp4|mov|avi)$/i)
      );
    },
    isAudio(img) {
      return (
        this._.isString(img) &&
        img
          .split('?')[0]
          .toLowerCase()
          .match(/.(wav|mp3)$/i)
      );
    },
    isMimeTypeImage(img) {
      return this._.isString(img) && img.match('image.*');
    },
    isMimeTypeVideo(img) {
      return this._.isString(img) && img.match('video.*');
    },
    isMimeTypeAudio(img) {
      return this._.isString(img) && img.match('audio.*');
    },
    getThumb(img) {
      if (this._.isString(img)) {
        let path = img.split('/');
        if (path.length > 0) {
          let filename = path[path.length - 1];
          let split = filename.split('.');
          if (split.length > 1) {
            split[0] = split[0] + '_thumb';

            if (this.isVideo(filename)) {
              //Need this for video file thumbs
              split[1] = 'png';
            } else if (this.isAudio(filename)) {
              //Need this for audio file thumbs
              return this.getDefaultAudioUrl();
            }
            path[path.length - 1] = split.join('.');
          }
          return path.join('/');
        }
      }
      return img;
    },
    sortedImages(images) {
      return images ? this._.orderBy(images, 'id') : images;
    },
    getImageByIndex(i, images) {
      let image = images[i % images.length];
      return this._.isString(image) ? image : this.getFirstImage(images);
    },
    getFirstImage(images) {
      let image =
        this._.isArray(images) && images.length > 0 ? images[0] : CONFIG.LOCATION_DEFAULT_IMAGE;
      return this._.isString(image) ? image : image;
    },
    removeDoubleSlash(str) {
      return this._.isString(str) ? str.replace(/\/\/+/g, '/') : str;
    },
    getSpotIconUrl(name, inactive = false) {
      // the server generates the monochrome _bw variant next to every _thumb
      const suffix = inactive ? '_bw' : '_thumb';
      return this.imageBaseUrl + `/img/waypoint_type_icons/${name}${suffix}.png`;
    },
    getTaskImageUrl(name) {
      return this.imageBaseUrl + `/teamgeist/picture/raetsel/${name}`;
    },

    getDefaultAudioUrl() {
      return this.imageBaseUrl + `/img/audio_thumb.png`;
    },

    getEventDefaultTaskImage(name) {
      return this.imageBaseUrl + `/teamgeist/picture/event/${name}`;
    },

    // raw file names of a step; without a step the tile default (description, else task)
    getStepMedia(item, type = null, isSolved = false) {
      let images = [];
      if (item) {
        if (item.raetsel && item.raetsel.rabilder) {
          if (type) {
            //Quest spots
            images =
              CONFIG.TASK_STEPPER_TASK == type
                ? item.raetsel.rabilder.task
                : CONFIG.TASK_STEPPER_AAC == type
                ? isSolved
                  ? item.raetsel.rabilder.aac
                  : item.raetsel.rabilder.aaw
                : item.raetsel.rabilder.descr;
          } else {
            //Default image
            images = this._.isEmpty(item.raetsel.rabilder.descr)
              ? item.raetsel.rabilder.task
              : item.raetsel.rabilder.descr;
          }
        } else if (item.bilder) {
          //Infospots
          images = CONFIG.TASK_STEPPER_AAC == type ? item.aac : item.bilder;
        }
      }
      return images || [];
    },

    // audio never shows in the gallery; it plays in the background of its step (getStepAudio)
    getGalleryImages(item, type = null, isSolved = false) {
      return this._.map(
        this._.reject(this.getStepMedia(item, type, isSolved), (media) => this.isAudio(media)),
        (image) => this.getTaskImageUrl(image)
      );
    },

    // first audio file of a step like the native apps; null without a step, no cross-step fallback
    getStepAudio(item, type, isSolved = false) {
      if (!type) {
        return null;
      }
      const audio = this._.find(this.getStepMedia(item, type, isSolved), (media) => this.isAudio(media));
      return audio ? this.getTaskImageUrl(audio) : null;
    },
  },
};
